import PropTypes from 'prop-types';
import {Component} from 'react';
import noChartIcon from '../images/no-chart.svg';
import './ChartViewer.scss';

export default class ChartViewer extends Component {
  static propTypes = {
    base64EncodedPngChartImage: PropTypes.string,
    altText: PropTypes.string,
    errorMessage: PropTypes.string,
  };

  render() {
    const {
      base64EncodedPngChartImage,
      altText = 'No chart available',
      errorMessage = 'No chart is available because there is not enough data for a statistically reliable output',
    } = this.props;

    return (
      <div className="ChartViewer">
        {base64EncodedPngChartImage
          ? <img className="chart-image" src={`data:image/png;base64,${base64EncodedPngChartImage}`} alt={altText}/>
          : <div className="place-holder">
            <div className="msg-top"><img src={noChartIcon} alt={altText}/></div>
            <div className="msg-bottom">
              <div className="msg-1">Sorry!</div>
              <div className="msg-2">{errorMessage}</div>
            </div>
          </div>
        }
      </div>
    );
  }
}